import React, {useState} from 'react';
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import PrivacyPolicy from "./legal/PrivacyPolicy";

const STORAGE_KEY = 'cookieNoticeDismissed';

/**
 * Baner informacyjny o plikach cookies. Konsola używa tylko ciasteczek niezbędnych,
 * więc nie ma tu zgody do wyrażenia. Jest tylko informacja i przycisk zamknięcia.
 * Dostęp do localStorage może rzucić wyjątek (tryb prywatny, blokada danych witryn),
 * wtedy baner jest pokazywany za każdym razem.
 */
const wasDismissed = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1';
  } catch (e) {
    return false;
  }
}

const CookieNotice = () => {
  const [visible, setVisible] = useState(() => !wasDismissed());

  const dismiss = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {
    }
    setVisible(false);
  }

  if (!visible) return null;

  return <div className="cookie-notice" role="status">
    <span>
      Konsola używa wyłącznie plików cookies niezbędnych do jej działania: do utrzymania połączenia i zalogowania.
      Szczegóły w <Link to={PrivacyPolicy.url}>Polityce prywatności</Link>.
    </span>
    <Button variant="primary" size="sm" onClick={dismiss}>Rozumiem</Button>
  </div>;
}

export default CookieNotice;
